export var valuesTreeOrientation = ["LR", "RL", "TB", "BT"];
//# sourceMappingURL=TreeOrientation.js.map